import { InfoCard } from "./Infocard";
export default InfoCard;
